module.exports = __webpack_public_path__ + "static/media/1012659.b93b6e63.jpg";